export default "/static/dashboard/build/app/img/v2/74cb3a8bddb00a63addc9301c2d95add.png";